import React from 'react'
import Typography from './foundations/typography/Typography'
import Icon from './foundations/icon/Icon'
import Button from './basics/button/Button'
import Grid from './foundations/grid/Grid'
import Translation from '../global/Translation'
import Switch from './basics/switch/Switch'
import PointProgressBar from './basics/point-progress-bar/PointProgressBar'
import ProgressBar from './basics/progress-bar/ProgressBar'
import Tab from './basics/tab/Tab'
import IconButton from './basics/icon-button/IconButton'
import Tabs from './basics/tabs/Tabs'
import HoverImage from './basics/hover-image/HoverImage'
import Cell from './foundations/grid/Cell'
import Foundation from './foundations/Foundation'
import Application from './moleculars/application/Application'
import Benefit from './moleculars/benefit/Benefit'
import DocumentLink from './moleculars/document-link/DocumentLink'
import ProductCard from './moleculars/product-card/ProductCard'
import Carousel from './basics/carousel/Carousel'
import BackHoverImage from './basics/back-hover-image/BackHoverImage'

class DesignSystemScreen extends React.Component {
    Icon = <Icon img="arrow_short"/>

    hImage =  <BackHoverImage
        hoverSrc="https://stgpromocionecommercepro.blob.core.windows.net/ecommerceimages/promotions_ecommerce/2021-09-03T11:39:17+00:00-BLANCO_MACAEL_800x800_(1).jpg"
        defaultSrc="https://stgpromocionecommercepro.blob.core.windows.net/ecommerceimages/promotions_ecommerce/2021-09-06T10:44:27+00:00-CALACATTA_GOLD_800x800.jpg"
        alt="Imagen con efecto hover"
    />

    render() {
           return (
            <div>
                <h1>Design System</h1>
                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Typography</h2>
                    <Grid neutral-900>
                        <Cell col-3>
                            <Typography typeface="title-xl-light">
                                Title XL Light
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="title-l-light">
                                Title L Light
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="title-l-regular">
                                Title L Regular
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="title-l-medium">
                                Title L Medium
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="title-m-medium">
                                Title M Medium
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="title-m-light">
                                Title M Light
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="title-s-light">
                                Title S Light
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="title-s-bold">
                                Title S Bold
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="title-xs-light">
                                Title XS Light
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="body-m-light">
                                Body M Light
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="body-m-medium">
                                Body M Medium
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="body-m-regular">
                                Body M Regular
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="body-s-light">
                                Body S Light
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="body-s-regular">
                                Body S Regular
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="body-xs-regular">
                                Body XS Regular
                            </Typography>
                        </Cell>
                        <Cell col-3>
                            <Typography typeface="body-xs-light">
                                Body XS Light
                            </Typography>
                        </Cell>
                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Colors</h2>
                    <Grid>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-8>
                                    <Typography typeface="title-l-regular" neutral-900>
                                        Neutral 900
                                    </Typography>
                                </Cell>
                                <Cell col-4>
                                    <Foundation back-neutral-900>
                                        <div style={{width:'36px', height: '36px', borderRadius: '50%'}}></div>
                                    </Foundation>
                                </Cell>
                            </Grid>
                        </Cell>

                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-8>
                                    <Typography typeface="title-l-regular" neutral-700>
                                        Neutral 700
                                    </Typography>
                                </Cell>
                                <Cell col-4>
                                    <Foundation back-neutral-700>
                                        <div style={{width:'36px', height: '36px', borderRadius: '50%'}}></div>
                                    </Foundation>
                                </Cell>
                            </Grid>
                        </Cell>

                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-8>
                                    <Typography typeface="title-l-regular" neutral-600>
                                        Neutral 600
                                    </Typography>
                                </Cell>
                                <Cell col-4>
                                    <Foundation back-neutral-600>
                                        <div style={{width:'36px', height: '36px', borderRadius: '50%'}}></div>
                                    </Foundation>
                                </Cell>
                            </Grid>
                        </Cell>

                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-8>
                                    <Cell col-8>
                                        <Typography typeface="title-l-regular" neutral-400>
                                            Neutral 400
                                        </Typography>
                                    </Cell>
                                </Cell>
                                <Cell col-4>
                                    <Foundation back-neutral-400>
                                        <div style={{width:'36px', height: '36px', borderRadius: '50%'}}></div>
                                    </Foundation>
                                </Cell>
                            </Grid>
                        </Cell>

                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-8>
                                    <Typography typeface="title-l-regular" neutral-100>
                                        Neutral 100
                                    </Typography>
                                </Cell>
                                <Cell col-4>
                                    <Foundation back-neutral-100>
                                        <div style={{width:'36px', height: '36px', borderRadius: '50%'}}></div>
                                    </Foundation>
                                </Cell>
                            </Grid>
                        </Cell>

                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-8>
                                    <Typography typeface="title-l-regular" accent-100>
                                        Accent 100
                                    </Typography>
                                </Cell>
                                <Cell col-4>
                                    <Foundation back-accent-100>
                                        <div style={{width:'36px', height: '36px', borderRadius: '50%'}}></div>
                                    </Foundation>
                                </Cell>
                            </Grid>
                        </Cell>

                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-8>
                                    <Typography typeface="title-l-regular" accent-50>
                                        Accent 50
                                    </Typography>
                                </Cell>
                                <Cell col-4>
                                    <Foundation back-accent-50>
                                        <div style={{width:'36px', height: '36px', borderRadius: '50%'}}></div>
                                    </Foundation>
                                </Cell>
                            </Grid>
                        </Cell>

                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-8>
                                    <Typography typeface="title-l-regular" white>
                                        White
                                    </Typography>
                                </Cell>
                                <Cell col-4>
                                    <Foundation back-white>
                                        <div style={{width:'36px', height: '36px', borderRadius: '50%'}}></div>
                                    </Foundation>
                                </Cell>
                            </Grid>
                        </Cell>

                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Icons</h2>
                    <Grid neutral-900>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        application_bath
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="shopping_cart" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        application_cladding
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="application_cladding" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        application_facade
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="application_facade" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        application_flooring
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="application_flooring" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        application_furniture
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="application_furniture" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        application_shower
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="application_shower" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        application_staircase
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="application_staircase" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        application_top
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="application_top" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        arrow_large
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="arrow_large" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        arrow_short
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="arrow_short" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        chevron_left
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="chevron_left" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        chevron_right
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="chevron_right" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        type_in_out
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="type_in_out" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        type_low
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="type_low" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        type_quality
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="type_quality" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        type_stain
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="type_stain" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        type_time
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="type_time" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        type_unique
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="type_unique" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        view_1
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="view_1" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-3>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-10>
                                    <Typography typeface="title-l-regular">
                                        view_2
                                    </Typography>
                                </Cell>
                                <Cell col-2>
                                    <Icon img="view_2" size={36}/>
                                </Cell>
                            </Grid>
                        </Cell>

                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Buttons</h2>
                    <Grid neutral-900>
                        <Cell col-4>
                            <Button size-l
                                    style-black
                                    onClick={() => alert('Black large')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Black large
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-m
                                    style-black
                                    onClick={() => alert('Black medium')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Black medium
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-s
                                    style-black
                                    onClick={() => alert('Black small')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Black small
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-l
                                    style-black
                                    disabled
                                    onClick={() => alert('Black large')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Black large disabled
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-m
                                    style-black
                                    disabled
                                    onClick={() => alert('Black medium')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Black medium disabled
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-s
                                    style-black
                                    disabled
                                    onClick={() => alert('Black small')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Black small disabled
                            </Button>
                        </Cell>

                        <Cell col-4>
                            <Button size-l
                                    style-white
                                    onClick={() => alert('White large')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                White large
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-m
                                    style-white
                                    onClick={() => alert('White medium')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                White medium
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-s
                                    style-white
                                    onClick={() => alert('Black small')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                White small
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-l
                                    style-white
                                    disabled
                                    onClick={() => alert('White large')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                White large disabled
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-m
                                    style-white
                                    disabled
                                    onClick={() => alert('White medium')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                White medium disabled
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-s
                                    style-white
                                    disabled
                                    onClick={() => alert('Black small')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                White small disabled
                            </Button>
                        </Cell>

                        <Cell col-4>
                            <Button size-l
                                    style-hero
                                    onClick={() => alert('Hero large')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Hero large
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-m
                                    style-hero
                                    onClick={() => alert('Hero medium')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Hero medium
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-s
                                    style-hero
                                    onClick={() => alert('Hero small')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Hero small
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-l
                                    style-hero
                                    disabled
                                    onClick={() => alert('Hero large')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Hero large disabled
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-m
                                    style-hero
                                    disabled
                                    onClick={() => alert('Hero medium')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Hero medium disabled
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-s
                                    style-hero
                                    disabled
                                    onClick={() => alert('Hero small')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Hero small disabled
                            </Button>
                        </Cell>

                        <Cell col-4>
                            <Button size-l
                                    style-link
                                    onClick={() => alert('Link large')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Link large
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-m
                                    style-link
                                    onClick={() => alert('Link medium')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Link medium
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-s
                                    style-link
                                    onClick={() => alert('Link small')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Link small
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-l
                                    style-link
                                    disabled
                                    onClick={() => alert('Link large')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Link large disabled
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-m
                                    style-link
                                    disabled
                                    onClick={() => alert('Link medium')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Link medium disabled
                            </Button>
                        </Cell>
                        <Cell col-4>
                            <Button size-s
                                    style-link
                                    disabled
                                    onClick={() => alert('Link small')}
                                    img="arrow_short"
                                    hImg="arrow_large"
                            >
                                Link small disabled
                            </Button>
                        </Cell>


                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Icon buttons</h2>
                    <Grid neutral-900>
                        <Cell col-6>
                            <Grid>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular">
                                                Primary L
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-l
                                                        style-primary
                                                        img="chevron_right"
                                                        onClick={() => alert('Primary L')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular" neutral-400>
                                                Primary L disabled
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-l
                                                        style-primary
                                                        disabled
                                                        img="chevron_right"
                                                        onClick={() => alert('Primary')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular">
                                                Primary M
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-m
                                                        style-primary
                                                        img="chevron_right"
                                                        onClick={() => alert('Primary M')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular" neutral-400>
                                                Primary M disabled
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-m
                                                        style-primary
                                                        disabled
                                                        img="chevron_right"
                                                        onClick={() => alert('Primary')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular">
                                                Primary S
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-s
                                                        style-primary
                                                        img="chevron_right"
                                                        onClick={() => alert('Primary S')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular" neutral-400>
                                                Primary S disabled
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-s
                                                        style-primary
                                                        disabled
                                                        img="chevron_right"
                                                        onClick={() => alert('Primary')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>

                            </Grid>
                        </Cell>


                        {/*Inverse*/}
                        <Cell col-6>
                            <Grid back-neutral-700>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular" accent-100>
                                                Inverse L
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-l
                                                        style-inverse
                                                        img="chevron_right"
                                                        onClick={() => alert('Inverse L')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular" neutral-400>
                                                Inverse L disabled
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-l
                                                        style-inverse
                                                        disabled
                                                        img="chevron_right"
                                                        onClick={() => alert('Primary')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular" accent-100>
                                                Inverse M
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-m
                                                        style-inverse
                                                        img="chevron_right"
                                                        onClick={() => alert('Inverse M')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular" neutral-400>
                                                Inverse M disabled
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-m
                                                        style-inverse
                                                        disabled
                                                        img="chevron_right"
                                                        onClick={() => alert('Primary')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular" accent-100>
                                                Inverse S
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-s
                                                        style-inverse
                                                        img="chevron_right"
                                                        onClick={() => alert('Inverse S')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>
                                <Cell col-6>
                                    <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                        <Cell col-8>
                                            <Typography typeface="title-l-regular" neutral-400>
                                                Inverse S disabled
                                            </Typography>
                                        </Cell>
                                        <Cell col-4>
                                            <IconButton size-s
                                                        style-inverse
                                                        disabled
                                                        img="chevron_right"
                                                        onClick={() => alert('Primary')}
                                            />
                                        </Cell>
                                    </Grid>
                                </Cell>

                            </Grid>
                        </Cell>
                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Switch</h2>
                    <Grid>
                        <Cell col-4>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-5>
                                    <Typography typeface="title-l-regular">
                                        48px
                                    </Typography>
                                </Cell>
                                <Cell col-1>
                                    <Switch img1="view_1"
                                            img2="view_2"
                                            size={48}
                                            onClickA={() => console.log('Switch 1')}
                                            onClickB={() => console.log('Switch 2')}
                                            className="mb-4"
                                    />
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-4>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-5>
                                    <Typography typeface="title-l-regular">
                                        36px
                                    </Typography>
                                </Cell>
                                <Cell col-1>
                                    <Switch img1="view_1"
                                            img2="view_2"
                                            size={36}
                                            onClickA={() => console.log('Switch 1')}
                                            onClickB={() => console.log('Switch 2')}
                                            className="mb-4"
                                    />
                                </Cell>
                            </Grid>
                        </Cell>
                        <Cell col-4>
                            <Grid style={{padding:'0', alignItems: 'center', gridGap: '0'}}>
                                <Cell col-5>
                                    <Typography typeface="title-l-regular">
                                        24px
                                    </Typography>
                                </Cell>
                                <Cell col-1>
                                    <Switch img1="view_1"
                                            img2="view_2"
                                            size={24}
                                            onClickA={() => console.log('Switch 1')}
                                            onClickB={() => console.log('Switch 2')}
                                            className="mb-4"
                                    />
                                </Cell>
                            </Grid>
                        </Cell>
                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Tabs</h2>
                    <Grid neutral-900>
                        <Cell col-2>
                            <Tab style-chip-s
                            >
                                Chip S
                            </Tab>
                        </Cell>
                        <Cell col-2>
                            <Tab style-chip-s disabled
                            >
                                Chip S disabled
                            </Tab>
                        </Cell>
                        <Cell col-2>
                            <Tab style-chip-m
                            >
                                Chip M
                            </Tab>
                        </Cell>
                        <Cell col-2>
                            <Tab style-chip-m disabled
                            >
                                Chip M disabled
                            </Tab>
                        </Cell>

                        <Cell col-2>
                            <Tab style-selector
                            >
                                Selector
                            </Tab>
                        </Cell>
                        <Cell col-2>
                            <Tab style-selector disabled
                            >
                                Selector disabled
                            </Tab>
                        </Cell>
                        <Cell col-2>
                            <Tab style-tab
                            >
                                Tab
                            </Tab>
                        </Cell>
                        <Cell col-2>
                            <Tab style-tab disabled
                            >
                                Tab disabled
                            </Tab>
                        </Cell>
                        <Cell col-4>
                            <Tabs
                                // fill
                                tabs={[
                                    {label: "Tab 0", onClick: () => console.log('Clicked tab 0')},
                                    {label: "Tab 1", onClick: () => console.log('Clicked tab 1')},
                                    {label: "Tab 2", onClick: () => console.log('Clicked tab 2')},
                                    {label: "Tab 3", onClick: () => console.log('Clicked tab 3')},
                                    {label: "Tab 4", onClick: () => console.log('Clicked tab 4')}
                                ]}
                            />
                        </Cell>
                        <Cell col-4>
                            <Tabs
                                fill
                                type="chip"
                                tabs={[
                                    {label: "Tab 0", onClick: () => console.log('Clicked tab 0')},
                                    {label: "Tab 1", onClick: () => console.log('Clicked tab 1')},
                                    {label: "Tab 2", onClick: () => console.log('Clicked tab 2')},
                                    {label: "Tab 3", onClick: () => console.log('Clicked tab 3')},
                                    {label: "Tab 4", onClick: () => console.log('Clicked tab 4')},
                                    {label: "Tab 5", onClick: () => console.log('Clicked tab 5')},
                                ]}
                            />
                        </Cell>
                    </Grid>
                </div>

                <div className="my-4 p-3 pb-5" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-5">Point progress bar</h2>
                    <Grid neutral-900>
                        <Cell col-2>
                            <PointProgressBar level={0}/>
                        </Cell>
                        <Cell col-2>
                            <PointProgressBar level={1}/>
                        </Cell>
                        <Cell col-2>
                            <PointProgressBar level={2}/>
                        </Cell>
                        <Cell col-2>
                            <PointProgressBar level={3}/>
                        </Cell>
                        <Cell col-2>
                            <PointProgressBar level={4}/>
                        </Cell>
                        <Cell col-2>
                            <PointProgressBar level={5}/>
                        </Cell>
                    </Grid>
                </div>

                <div className="my-4 p-3 pb-5" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-5">Progress bar</h2>
                    <Grid neutral-900>
                        <Cell col-2>
                            <ProgressBar level={0}/>
                        </Cell>
                        <Cell col-2>
                            <ProgressBar level={1}/>
                        </Cell>
                        <Cell col-2>
                            <ProgressBar level={2}/>
                        </Cell>
                        <Cell col-2>
                            <ProgressBar level={3}/>
                        </Cell>
                        <Cell col-2>
                            <ProgressBar level={4}/>
                        </Cell>
                        <Cell col-2>
                            <ProgressBar level={5}/>
                        </Cell>
                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Hover image</h2>
                    <div style={{height:'200px'}}>
                        {this.hImage}
                    </div>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Grid</h2>
                    <Grid back-neutral-400>
                        <Icon img="type_quality" neutral-600/>
                        <Icon img="type_quality" neutral-600/>
                        <Cell col-2>
                            {this.hImage}
                        </Cell>
                        {this.hImage}
                        {this.hImage}
                        <Icon img="type_unique" neutral-600/>
                        {this.hImage}
                        {this.hImage}
                        {this.hImage}
                        {this.hImage}
                        {this.hImage}
                        {this.hImage}
                        <Typography typeface="body-m-light" neutral-600>
                            Lorem ipsum dolor sit amet
                        </Typography>
                        {this.hImage}
                        {this.hImage}
                        {this.hImage}
                        {this.hImage}
                        {this.hImage}
                        <Icon img="type_quality" neutral-600/>
                        {this.hImage}
                        {this.hImage}
                        {this.hImage}
                        {this.hImage}
                        <Icon img="type_quality" neutral-600/>
                        {this.hImage}
                        {this.hImage}
                        <Cell col-3>
                            <Typography typeface="body-m-light" neutral-600>
                                Lorem ipsum dolor sit amet
                            </Typography>
                        </Cell>
                        {this.hImage}
                        {this.hImage}
                        <Icon img="type_quality" neutral-600/>
                        {this.hImage}
                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Application</h2>
                    <Grid>
                        <Cell col-4>
                            <Application level={2} icon="application_shower" >
                                Kitchen Island / top
                            </Application>
                        </Cell>
                        <Cell col-4>
                            <Application level={3} icon="application_furniture" >
                                Furniture
                            </Application>
                        </Cell>
                        <Cell col-4>
                            <Application level={4} icon="application_cladding" >
                                Interior cladding
                            </Application>
                        </Cell>
                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Benefit</h2>
                    <Grid>
                        <Cell col-3>
                            <Benefit icon="application_furniture" >
                                <Translation id="furniture" defaultMessage="Furniture" />
                                <Translation id="benefit_tes" defaultMessage="El beneficio de la duda no me deja coberture.
                                    Mientras tanto, aquí sigo esperando, a que pase el rato mientras los segundos van pasando,
                                    sin prisa, despacio. Y la vida, eso que me atormenta, se va agotando."/>
                            </Benefit>
                        </Cell>
                    </Grid>
                </div>

                <div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>
                    <h2 className="mb-4">Document Link</h2>
                    <Grid>
                        <Cell col-2 center>
                            <DocumentLink brand="scalea">
                                <Translation id="sensa_countertops" defaultMessage="SENSA COUNTERTOPS DESIGN AND INSTALLATION GUIDE" />
                                <Translation id="granites_and_quartzites" defaultMessage="Granites and Quartzites."/>
                            </DocumentLink>
                        </Cell>
                        <Cell col-2 center>
                            <DocumentLink brand="sensa">
                                <Translation id="scalea_countertops" defaultMessage="SCALEA COUNTERTOPS DESIGN AND INSTALLATION GUIDE" />
                                <Translation id="granites_and_quartzites" defaultMessage="Granites and Quartzites."/>
                            </DocumentLink>
                        </Cell>
                        <Cell col-2 center>
                            <DocumentLink brand="scalea">
                                <Translation id="sensa_countertops" defaultMessage="SENSA COUNTERTOPS DESIGN AND INSTALLATION GUIDE" />
                                <Translation id="granites_and_quartzites" defaultMessage="Granites and Quartzites."/>
                            </DocumentLink>
                        </Cell>
                        <Cell col-2 center>
                            <DocumentLink brand="sensa">
                                <Translation id="scalea_countertops" defaultMessage="SCALEA COUNTERTOPS DESIGN AND INSTALLATION GUIDE" />
                                <Translation id="granites_and_quartzites" defaultMessage="Granites and Quartzites."/>
                            </DocumentLink>
                        </Cell>
                        <Cell col-2 center>
                            <DocumentLink brand="scalea">
                                <Translation id="sensa_countertops" defaultMessage="SENSA COUNTERTOPS DESIGN AND INSTALLATION GUIDE" />
                                <Translation id="granites_and_quartzites" defaultMessage="Granites and Quartzites."/>
                            </DocumentLink>
                        </Cell>
                        <Cell col-2 center>
                            <DocumentLink brand="sensa">
                                <Translation id="scalea_countertops" defaultMessage="SCALEA COUNTERTOPS DESIGN AND INSTALLATION GUIDE" />
                                <Translation id="granites_and_quartzites" defaultMessage="Granites and Quartzites."/>
                            </DocumentLink>
                        </Cell>
                    </Grid>
                </div>


                {/*<div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>*/}
                {/*    <h2 className="mb-4">Product card</h2>*/}
                {/*    <Grid back-white>*/}
                {/*        <Cell col-4 center>*/}
                {/*            <ProductCard src='https://stgpromocionecommercepro.blob.core.windows.net/ecommerceimages/promotions_ecommerce/2021-09-03T11:39:17+00:00-BLANCO_MACAEL_800x800_(1).jpg'/>*/}
                {/*        </Cell>*/}
                {/*        <Cell col-4 center>*/}
                {/*            <ProductCard src='https://stgpromocionecommercepro.blob.core.windows.net/ecommerceimages/promotions_ecommerce/2021-09-03T11:39:17+00:00-BLANCO_MACAEL_800x800_(1).jpg'/>*/}
                {/*        </Cell>*/}
                {/*        <Cell col-4 center>*/}
                {/*            <ProductCard src='https://stgpromocionecommercepro.blob.core.windows.net/ecommerceimages/promotions_ecommerce/2021-09-03T11:39:17+00:00-BLANCO_MACAEL_800x800_(1).jpg'/>*/}
                {/*        </Cell>*/}
                {/*    </Grid>*/}
                {/*</div>*/}

                {/*<div className="my-4 p-3" style={{backgroundColor: '#dddddd'}}>*/}
                {/*    <h2 className="mb-4">Carousel</h2>*/}
                {/*    <Carousel*/}
                {/*        //showButtons={false}*/}
                {/*        // count={3}*/}
                {/*        section='DESIGN SYSTEM'*/}
                {/*        items={[*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/9J/detalle/9J-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/9H/detalle/9H-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/9D/detalle/9D-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/PI5/detalle/PI5-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/LSJ/detalle/LSJ-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/HDA/detalle/HDA-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/9J/detalle/9J-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/9H/detalle/9H-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/9D/detalle/9D-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*            <ProductCard src='https://assetstools.cosentino.com/api/v1/bynder/color/9M/detalle/9M-detail.jpg?w=2000&h=1200&fit=crop&auto=compress,format'/>,*/}
                {/*        ]}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default DesignSystemScreen
